import React, { useState } from "react";
import { Box, Stack } from "@mui/joy";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { Dayjs } from "dayjs";
import "dayjs/locale/ko";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { RightArrowSvg } from "static/image/common/SvgAssets";
import { formatKoreanMonthDay } from "utils/subscriptionPauseUtils";

// 행은 직접 풀폭으로 렌더하고, 캘린더는 앵커가 필요 없는 MobileDatePicker(모달)로
// 띄운다. field slot 은 빈 요소로 숨겨 레이아웃에 관여하지 않게 한다.
export default function PauseDateRow({
  label,
  value,
  onChange,
  minDate,
  maxDate,
  disabled,
}: {
  label: string;
  value: Dayjs;
  onChange: (value: Dayjs) => void;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Stack
        direction={"row"}
        width={"100%"}
        height={"48px"}
        justifyContent="space-between"
        alignItems="center"
        sx={{
          px: "12px",
          cursor: disabled ? "default" : "pointer",
          opacity: disabled ? 0.4 : 1,
        }}
        onClick={() => {
          if (!disabled) setOpen(true);
        }}
      >
        {/* 라벨·값·화살표는 알림 설정(NotificationSettingsPage) 행과 동일 스펙.
            Figma 8060:2611: 라벨 Body 16/500/Strong, 값 14/500/Weak, chevron SuperWeak. */}
        <CustomTypography
          variant={"Body"}
          sx={{ fontWeight: 500, color: theme.vars.palette.Content.Strong }}
        >
          {label}
        </CustomTypography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: 0,
            color: theme.vars.palette.Content.Weak,
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          {formatKoreanMonthDay(value)}
          <RightArrowSvg color={theme.vars.palette.Content.SuperWeak} />
        </Box>
      </Stack>

      {/* picker 는 flex 흐름에서 제외(0x0). 모달은 body 로 portal 되어 영향 없음. */}
      <Box
        sx={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"ko"}>
          <MobileDatePicker
            value={value}
            open={open}
            onClose={() => setOpen(false)}
            minDate={minDate}
            maxDate={maxDate}
            onAccept={(next) => {
              if (next) onChange(next);
            }}
            slots={{ field: () => null }}
            slotProps={{
              toolbar: { toolbarFormat: "MMMM DD일" },
              actionBar: { actions: ["cancel", "accept"] },
            }}
            localeText={{
              cancelButtonLabel: "취소",
              okButtonLabel: "확인",
              toolbarTitle: "날짜를 선택하세요",
            }}
          />
        </LocalizationProvider>
      </Box>
    </Box>
  );
}
